import { useRoutes } from "react-router-dom";
import AutoLoginFn from "@components/login/AutoLoginFn";
import routes from "@router/Router";
const Ehp = () => {
    const content = useRoutes(routes);
    AutoLoginFn();
    return content;
};
export default Ehp;
